export const tutorials = {
    state: {
        tutorials: []
    },
    mutations: {
        SET_TUTORIALS_SNIPPETS(state, payload) {
            let snippetContent = []
            payload.snippetContentResponseList.forEach(el => {
                const snippetData = JSON.parse(
                    el.content.replace(/(\r\n|\n|\r)/gm, '')
                )
                snippetContent = snippetContent.concat(snippetData)
            })
            state.tutorials = snippetContent
        }
    },
    getters: {
        getTutorials: state => state.tutorials
    }
}
